module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#instagram",
      toString: function () {
        return this.url;
      }
    }